import { combineReducers } from 'redux';

import authReducer from './auth.reducer';
import menuReducer from './menu.reducer';
import countryReducer from './country.reducer';
import globalDataReducer from './global.reducer';
import mediaQueryReducer from './mediaQuery.reducer';

export default combineReducers({
  auth: authReducer,
  menu: menuReducer,
  country: countryReducer,
  globalData: globalDataReducer,
  mediaQuery: mediaQueryReducer,
});
